import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/pages/index.vue')
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('@/pages/account/index.vue')
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('@/pages/download/index.vue')
  },
  {
    path: '/live',
    name: 'live',
    component: () => import('@/pages/live/index.vue')
  },
  {
    path: '/live/player/:id',
    name: 'livePlayer',
    component: () => import('@/pages/live/player/_id.vue')
  },
  {
    path: '/login/login',
    name: 'login',
    component: () => import('@/pages/login/login.vue')
  },
  {
    path: '/login/register',
    name: 'register',
    component: () => import('@/pages/login/register.vue')
  },
  {
    path: '/login/forget',
    name: 'forget',
    component: () => import('@/pages/login/forget.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/pages/news/index.vue')
  },
  {
    path: '/news/details/:id',
    name: 'newsDetails',
    component: () => import('@/pages/news/details/_id.vue')
  },
  {
    path: '/personal',
    name: 'personal',
    component: () => import('@/pages/personal/index.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/pages/search/index.vue')
  },
  {
    path: '/subject',
    name: 'subject',
    component: () => import('@/pages/subject/index.vue')
  },
  {
    path: '/subject/details/:id',
    name: 'subjectDetails',
    component: () => import('@/pages/subject/details/_id.vue')
  },
  {
    path: '/subject/detail/:id',
    name: 'subjectSecond',
    component: () => import('@/pages/subject/secondLevel.vue')
  },
  {
    path: '/tags',
    name: 'tags',
    component: () => import('@/pages/tags/index.vue')
  },
  {
    path: '/video',
    name: 'video',
    component: () => import('@/pages/video/index.vue')
  },
  {
    path: '/video/player/:id',
    name: 'videoPlayer',
    component: () => import('@/pages/video/player/_id.vue')
  },
  {
    path: '/workcard',
    name: 'workcard',
    component: () => import('@/pages/workcard/index.vue')
  },
  {
    path: '/workcard/show/:id',
    name: 'workcardShow',
    component: () => import('@/pages/workcard/show/_id.vue')
  }
]

const router = new Router({
  mode: 'history',
  routes
})

export default router
